import React from 'react';
import { Stack, Skeleton, Box } from '@mui/material';

interface ICandidateInterviewFeedbackCountsSkeletonProps {}

const CandidateInterviewFeedbackCountsSkeleton = (
  props: ICandidateInterviewFeedbackCountsSkeletonProps
) => {
  return (
    <Stack
      id='candidate-interview-feedback-counts'
      data-testid='candidate-interview-feedback-counts'
      spacing={2}
      justifyContent='center'
    >
      <Box sx={{ display: 'flex', flexDirection: 'row', mb: '10px' }}>
        <Skeleton
          variant='rectangular'
          width='1.5rem'
          height={24}
          sx={{
            bgcolor: (theme) => theme.palette.neutral?.main,
          }}
        />
        <Skeleton
          variant='rectangular'
          width='8.188rem'
          height={20}
          sx={{
            mt: '0rem',
            ml: '0.625rem',
            bgcolor: (theme) => theme.palette.neutral?.main,
          }}
        />
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'row', mb: '10px' }}>
        <Skeleton
          variant='rectangular'
          width='1.5rem'
          height={24}
          sx={{
            bgcolor: (theme) => theme.palette.neutral?.main,
          }}
        />
        <Skeleton
          variant='rectangular'
          width='11.375rem'
          height={20}
          sx={{
            mt: '0rem',
            ml: '0.625rem',
            bgcolor: (theme) => theme.palette.neutral?.main,
          }}
        />
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        <Skeleton
          variant='rectangular'
          width='1.5rem'
          height={24}
          sx={{
            bgcolor: (theme) => theme.palette.neutral?.main,
          }}
        />
        <Skeleton
          variant='rectangular'
          width='3.375rem'
          height={20}
          sx={{
            mt: 'none',
            ml: '0.625rem',
            bgcolor: (theme) => theme.palette.neutral?.main,
          }}
        />
      </Box>
    </Stack>
  );
};

export default CandidateInterviewFeedbackCountsSkeleton;
